import { Header as FHeader, Navigation } from 'festo-react-ui-kit';
import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { clearFilter } from '../../features/filter/filterSlice';
import { useNormalizeAssetPath } from '../../features/base/hooks/useBase';

const Header: React.FC = () => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  const dispatch = useAppDispatch();
  const normalizeAssetPath = useNormalizeAssetPath();
  const base = useAppSelector((state) => state.base);

  function handleLogoClick(e: React.MouseEvent) {
    e.preventDefault();
    linkRef.current?.click();
    dispatch(clearFilter);
  }

  return (
    <FHeader>
      <NavLink ref={linkRef} to="" className="navlink" />
      <Navigation
        logoHref={`#${base.baseName}`}
        onLogoClick={handleLogoClick}
        logoSrc={normalizeAssetPath('img/logo_blue.svg')}
      />
    </FHeader>
  );
};

export default Header;
